/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BinaryFileType } from '../models/binary-file-type';
import { getCarrierDeliveryNoteCombinedPdf } from '../fn/delivery-notes/get-carrier-delivery-note-combined-pdf';
import { GetCarrierDeliveryNoteCombinedPdf$Params } from '../fn/delivery-notes/get-carrier-delivery-note-combined-pdf';

@Injectable({ providedIn: 'root' })
export class CarrierService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCarrierDeliveryNoteCombinedPdf()` */
  static readonly GetCarrierDeliveryNoteCombinedPdfPath = '/organization-sites/{organizationSiteKey}/carrier/delivery-notes/{deliveryNoteKey}/complete-pdf';

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures and all images as a carrier
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCarrierDeliveryNoteCombinedPdf()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDeliveryNoteCombinedPdf$Response(params: GetCarrierDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<StrictHttpResponse<BinaryFileType>> {
    return getCarrierDeliveryNoteCombinedPdf(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a complete pdf with checkout and checkin data.
   *
   * Get a complete pdf with checkout and checkin data: the delivery note,
   * all attachments, all signatures and all images as a carrier
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCarrierDeliveryNoteCombinedPdf$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCarrierDeliveryNoteCombinedPdf(params: GetCarrierDeliveryNoteCombinedPdf$Params, context?: HttpContext): Observable<BinaryFileType> {
    return this.getCarrierDeliveryNoteCombinedPdf$Response(params, context).pipe(
      map((r: StrictHttpResponse<BinaryFileType>): BinaryFileType => r.body)
    );
  }

}
